import Request from '@/requests/Request'

const resource = "/organizacoes";

export default {
  findAll() {
      return Request.get(`${resource}`)
  },
  findById(organizacaoId) {
      return Request.get(`${resource}/${organizacaoId}`)
  },
  post(organizacao) {
    return Request.post(`${resource}`, organizacao)
  },
  put(id, organizacaoForm) {
    return Request.put(`${resource}/${id}`, organizacaoForm)
  },
  delete(organizacaoId) {
    return Request.delete(`${resource}/${organizacaoId}`)
  },  
}
